<template>
  <div>
    <dashboard-title></dashboard-title>
    <v-row>
      <v-col cols="12" lg="6">
        <todo-list></todo-list>
      </v-col>
      <v-col cols="12" lg="6">
        <notice-list></notice-list>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <my-schedule></my-schedule>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DashboardTitle from "@/components/dashboard/DashboardTitle";
import TodoList from "@/components/dashboard/TodoList";
import NoticeList from "@/components/dashboard/NoticeList";
import MySchedule from "@/components/dashboard/MySchedule";
export default {
  components: { DashboardTitle, TodoList, NoticeList, MySchedule },
};
</script>

<style></style>
